
import { defineComponent, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import { apiEndpoint } from "@/mixin/apiEndpoint";

export default defineComponent({
  mixins: [apiEndpoint],
  name: "employee view",
  components: {},
  data() {
    return {
      trainer: {},
      api_url: "",
      employeeInfo:{},
      empDistricts: [],
      load: false,
      id: this.$route.params.id,
      tabIndex: ref(0),
    };
  },
  async created() {
    this.api_url = this.VUE_APP_API_URL;
    this.load = true;
    await this.getEmployeeDetails();
  },
  methods: {
    setActiveTab(event) {
      this.tabIndex = parseInt(event.target.getAttribute("data-tab-index"));
    },
    async getEmployeeDetails() {
      this.load = true;
      await ApiService.get("configurations/employee/show/" + `${this.id}`)
        .then((response) => {
          this.load = false;
          this.employeeInfo = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
});
